var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-label": "Arrow pointing down"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.467 17.94V3.75a.75.75 0 0 1 1.5 0v14.19l6.186-6.187a.75.75 0 1 1 1.061 1.061l-7.467 7.467a.749.749 0 0 1-.311.187h-.002a.727.727 0 0 1-.2.032H12.2a.727.727 0 0 1-.2-.032h-.001a.749.749 0 0 1-.311-.187L4.22 12.814a.75.75 0 1 1 1.06-1.061l6.187 6.187z"
  })));
};
export default SvgArrowDown;